<template>
    <div class="dashboard">
        <h1 class="ml-0">Page Templates</h1>

        <div class="card rounded-lg">
            <!----><!---->
            <div class="card-body">
                <!----><!---->
                <div class="card-deck">
                    <ul>
                        <li>
                            <router-link
                                :to="{
                                    name: 'page_left_nav'
                                }"
                            >
                                Page with left nav (page-left-nav)
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{
                                    name: 'page_list'
                                }"
                            >
                                Page for listing (page-list)
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <!----><!---->
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            resources: {}
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
};
</script>
